import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import newsSpecialArticles from '../data/newsspecialarticles';
import recipeArticles from '../data/recipes.js';
import InterviewDoctorCardioA1 from '../components/interview_doctor_cardio_a1.jsx';
import InterviewDoctorOrthoA1 from '../components/interview_doctor_ortho_a1.jsx';
import InterviewDoctorOrthoA2 from '../components/interview_doctor_ortho_a2.jsx';
import InterviewGyneA1 from '../components/interview_doctor_gynec_a1.jsx';
import BusinessStockMarketTrends from '../components/curaffairs_BusinessStockMarketTrends.jsx';
import GlobalUnrestImpact from '../components/curaffairs_GlobalUnrestImpact.jsx';
import AIScienceTechnology from '../components/curaffairs_sciencetechnology_ai.jsx';
import BullionBearishOutlook from '../components/curaffairs_commoditybulliontrends.jsx';
import AIDisruptionRajan from '../components/curaffairs_aiimpact_raghurajan.jsx';
import MiddleEastWarImpact from '../components/curaffairs_middleeastconflict_asianmarkets.jsx';
import YogaBeginnersArticle from '../components/lifestyle_yogaforbeginers.jsx';
import CuraffairsAutomationautomobile from '../components/curaffairs_Automation_automobile.jsx';
const interviewComponents = {
  1: InterviewDoctorCardioA1,
  2: InterviewDoctorOrthoA1,
  3: InterviewDoctorOrthoA2,
  4: InterviewGyneA1,
};

const curaffairsComponents = {
  101: BusinessStockMarketTrends,
  102: GlobalUnrestImpact,
  103: AIScienceTechnology,
  104: BullionBearishOutlook,
  105: AIDisruptionRajan,
  106: MiddleEastWarImpact,
  107: CuraffairsAutomationautomobile,
};

const lifestyleComponents = {
  201: YogaBeginnersArticle,
};

const getPostedLabel = (postedtime) => (postedtime ? `Posted: ${postedtime}` : '');
const getPostedTimestamp = (postedtime) => {
  const parsed = Date.parse(postedtime || '');
  return Number.isNaN(parsed) ? 0 : parsed;
};


// RecipeList component for expand/collapse
function RecipeList({ recipeArticles }) {
  const [expanded, setExpanded] = useState({});

  const handleToggle = (aid) => {
    setExpanded(prev => ({ ...prev, [aid]: !prev[aid] }));
  };

  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: '0.3rem 0 0 0' }}>
      {recipeArticles.map((article, idx) => {
        const lines = article.aboutdescription ? article.aboutdescription.split('\n') : [];
        const isExpanded = expanded[article.aid];
        const showLines = isExpanded ? lines : lines.slice(0, 4);
        const canExpand = lines.length > 4;
        return (
          <React.Fragment key={idx}>
            <li style={{ padding: '0.7rem', display: 'block' }}>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', flexDirection: 'row' }}>
                <div style={{ width: 100, height: 80, borderRadius: 6, overflow: 'hidden', background: '#ddd', flexShrink: 0 }}>
                  <img
                    src={article.imagepath || '/defaultimages/imagenotavailable.jpg'}
                    alt={article.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={e => { e.target.onerror = null; e.target.src = '/defaultimages/imagenotavailable.jpg'; }}
                  />
                </div>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginLeft: 12 }}>
                  <div style={{ fontWeight: 600, fontSize: '0.92rem', marginBottom: '0.4rem', color: '#1976d2' }}>{article.title}</div>
                  {(article.postedtime || article.recipeby) && (
                    <div style={{ color: '#666', fontSize: '0.76rem', marginBottom: 6, fontWeight: 500 }}>
                      {article.postedtime ? getPostedLabel(article.postedtime) : ''}
                      {article.postedtime && article.recipeby ? ' | ' : ''}
                      {article.recipeby ? `by: ${article.recipeby}` : ''}
                    </div>
                  )}
                  {article.subtitle && (
                    <div style={{ color: article.subtitleColor || '#b8860b', fontWeight: 600, fontSize: '0.90rem', marginBottom: 4 }}>
                      {article.subtitle}
                    </div>
                  )}
                </div>
              </div>
              {/* Aboutdescription below image, extreme left */}
              <div style={{ color: '#333', fontSize: '0.82rem', lineHeight: 1.6, wordWrap: 'break-word', whiteSpace: 'pre-wrap', overflowWrap: 'break-word', marginTop: 8, textAlign: 'left', maxWidth: '100%' }}>
                {showLines.map((line, i) => (
                  <div key={i} style={{ marginBottom: 4 }}>{line}</div>
                ))}
                {canExpand && !isExpanded && (
                  <span style={{ color: '#1976d2', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleToggle(article.aid)}>
                    <b>Read more</b>
                  </span>
                )}
                {canExpand && isExpanded && (
                  <span style={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600 }} onClick={() => handleToggle(article.aid)}>
                    Show less
                  </span>
                )}
              </div>
            </li>
            {(idx + 1) % 3 === 0 && (
              <li key={`ad-re-${idx}`} style={{ padding: '0.7rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* Google Ad Placeholder */}
                <div style={{ width: 320, height: 100, background: '#f5f5f5', border: '1px dashed #ccc', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 18 }}>
                  Google Ad
                </div>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
}

const Specials = () => {

  const [openAid, setOpenAid] = useState(null);
  const [activeTab, setActiveTab] = useState('Your Doctor');


  // Assign articles to tabs based on specialcategory
  const yourDoctorArticles = newsSpecialArticles
    .filter(item => item.liststatus === 'Active' && (!item.specialcategory || item.specialcategory === 'Your Doctor'))
    .sort((a, b) => getPostedTimestamp(b.postedtime) - getPostedTimestamp(a.postedtime));

  const currentAffairsArticles = newsSpecialArticles
    .filter(item => item.liststatus === 'Active' && item.specialcategory === 'Current Affairs')
    .sort((a, b) => getPostedTimestamp(b.postedtime) - getPostedTimestamp(a.postedtime));

  const lifeStyleArticles = newsSpecialArticles
    .filter(item => item.liststatus === 'Active' && item.specialcategory === 'Life Style')
    .sort((a, b) => getPostedTimestamp(b.postedtime) - getPostedTimestamp(a.postedtime));

  const activeRecipeArticles = recipeArticles
    .filter(item => item.liststatus === 'Active')
    .sort((a, b) => getPostedTimestamp(b.postedtime) - getPostedTimestamp(a.postedtime));

  // Recipe articles are now imported from recipes.js

  const handleCardClick = (aid) => {
    setOpenAid(aid);
  };

  const handleCloseModal = () => {
    setOpenAid(null);
  };

  return (
    <div style={{ width: '100%', maxWidth: '100vw', margin: 0, padding: 10, boxSizing: 'border-box', overflowX: 'hidden' }}>
      <header style={{ position: 'relative', background: '#e8edf3ff', color: '#37864fff', padding: '0.25rem', textAlign: 'center', borderRadius: 8, marginBottom: 2 }}>
        <Link
          to="/home"
          aria-label="Back to home"
          style={{
            position: 'absolute',
            top: 2,
            left: 8,
            color: '#1976d2',
            fontSize: '1.5rem',
            fontWeight: 800,
            textDecoration: 'none',
            lineHeight: 1,
          }}
          title="Back to home"
        >
          ←
        </Link>
        <h1 style={{ margin: 0, marginTop: 0, fontSize: '1.0rem', fontWeight: 700 }}>Special</h1>
      </header>
      {/* Tabs */}
      <div style={{ display: 'flex', justifyContent: 'center', margin: '1rem 0 0.5rem 0', gap: 8 }}>
        {['Your Doctor', 'Current Affairs', 'Life Style', 'Recipe'].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '0.5rem 1.2rem',
              borderRadius: 6,
              border: 'none',
              background: activeTab === tab ? '#1976d2' : '#e8edf3',
              color: activeTab === tab ? '#fff' : '#1976d2',
              fontWeight: 600,
              fontSize: '0.80rem',
              cursor: 'pointer',
              boxShadow: activeTab === tab ? '0 2px 8px #1976d233' : 'none',
              transition: 'all 0.2s',
            }}
          >
            {tab}
          </button>
        ))}
      </div>
      {activeTab === 'Recipe' && (
        activeRecipeArticles.length > 0 ? (
          <RecipeList recipeArticles={activeRecipeArticles} />
        ) : (
          <div style={{ margin: '2rem 0', textAlign: 'center', color: '#888', fontSize: '1.1rem' }}>
            <p>No Recipe articles yet.</p>
          </div>
        )
      )}


      {/* Tab Content */}
      {activeTab === 'Your Doctor' && (
        <ul style={{ listStyle: 'none', padding: 0, margin: '0.3rem 0 0 0' }}>
          {yourDoctorArticles.map((article, idx) => (
            <React.Fragment key={idx}>
              <li onClick={() => setOpenAid(article.aid)} style={{ padding: '0.7rem', display: 'flex', gap: '0.5rem', alignItems: 'flex-start', cursor: 'pointer', flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }} onClick={() => handleCardClick(article.aid)}>
                  <div style={{ width: 100, height: 80, borderRadius: 6, overflow: 'hidden', background: '#ddd', flexShrink: 0 }}>
                    <img
                      src={article.imagepath || '/defaultimages/imagenotavailable.jpg'}
                      alt={article.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={e => { e.target.onerror = null; e.target.src = '/defaultimages/imagenotavailable.jpg'; }}
                    />
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: '0.92rem', marginBottom: '0.4rem', color: '#1976d2' }}>{article.title}</div>
                    {article.postedtime && (
                      <div style={{ color: '#666', fontSize: '0.76rem', marginBottom: 6, fontWeight: 500 }}>
                        {getPostedLabel(article.postedtime)}
                      </div>
                    )}
                    <div style={{ color: '#333', fontSize: '0.82rem', lineHeight: 1.6, wordWrap: 'break-word', whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                      {article.aboutdescription && article.aboutdescription.split('\n').map((line, i) => (
                        <div key={i} style={{ marginBottom: 4 }}>{line}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </li>
              {(idx + 1) % 3 === 0 && (
                <li key={`ad-${idx}`} style={{ padding: '0.7rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {/* Google Ad Placeholder */}
                  <div style={{ width: 320, height: 100, background: '#f5f5f5', border: '1px dashed #ccc', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 18 }}>
                    Google Ad
                  </div>
                </li>
              )}
            </React.Fragment>
          ))}
        </ul>
      )}

      {activeTab === 'Current Affairs' && (
        currentAffairsArticles.length > 0 ? (
          <ul style={{ listStyle: 'none', padding: 0, margin: '0.3rem 0 0 0' }}>
            {currentAffairsArticles.map((article, idx) => {
              const curaffairsAid = curaffairsComponents[article.aid] ? article.aid : null;
              return (
                <React.Fragment key={idx}>
                  <li style={{ padding: '0.7rem', display: 'flex', gap: '0.5rem', alignItems: 'flex-start', cursor: curaffairsAid ? 'pointer' : 'default', flexDirection: 'column' }}
                      onClick={() => curaffairsAid && setOpenAid(curaffairsAid)}>
                    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                      <div style={{ width: 100, height: 80, borderRadius: 6, overflow: 'hidden', background: '#ddd', flexShrink: 0 }}>
                        <img
                          src={article.imagepath || '/defaultimages/imagenotavailable.jpg'}
                          alt={article.title}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          onError={e => { e.target.onerror = null; e.target.src = '/defaultimages/imagenotavailable.jpg'; }}
                        />
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: '0.92rem', marginBottom: '0.4rem', color: '#1976d2' }}>{article.title}</div>
                        {article.postedtime && (
                          <div style={{ color: '#666', fontSize: '0.76rem', marginBottom: 6, fontWeight: 500 }}>
                            {getPostedLabel(article.postedtime)}
                          </div>
                        )}
                        <div style={{ color: '#333', fontSize: '0.82rem', lineHeight: 1.6, wordWrap: 'break-word', whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                          {article.aboutdescription && article.aboutdescription.split('\n').map((line, i) => (
                            <div key={i} style={{ marginBottom: 4 }}>{line}</div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </li>
                  {(idx + 1) % 3 === 0 && (
                    <li key={`ad-ca-${idx}`} style={{ padding: '0.7rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* Google Ad Placeholder */}
                      <div style={{ width: 320, height: 100, background: '#f5f5f5', border: '1px dashed #ccc', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 18 }}>
                        Google Ad
                      </div>
                    </li>
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        ) : (
          <div style={{ margin: '2rem 0', textAlign: 'center', color: '#888', fontSize: '1.1rem' }}>
            <p>No Current Affairs articles yet.</p>
          </div>
        )
      )}

      {activeTab === 'Life Style' && (
        lifeStyleArticles.length > 0 ? (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {lifeStyleArticles.map((article, idx) => (
              <React.Fragment key={idx}>
                <li onClick={() => setOpenAid(article.aid)} style={{ padding: '16px', display: 'flex', gap: '16px', alignItems: 'flex-start', cursor: 'pointer', flexDirection: 'column', margin: '12px 0', background: '#fff', borderRadius: 10, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', transition: 'all 0.3s ease', border: '1px solid #f0f0f0' }}>
                  <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', width: '100%' }}>
                    <div style={{ width: 110, height: 90, borderRadius: 8, overflow: 'hidden', background: '#f0f0f0', flexShrink: 0, boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)' }}>
                      <img
                        src={article.imagepath || '/defaultimages/imagenotavailable.jpg'}
                        alt={article.title}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onError={e => { e.target.onerror = null; e.target.src = '/defaultimages/imagenotavailable.jpg'; }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: '1.02rem', marginBottom: '8px', color: '#1976d2', lineHeight: 1.3 }}>{article.title}</div>
                      {article.postedtime && (
                        <div style={{ color: '#666', fontSize: '0.76rem', marginBottom: 8, fontWeight: 500 }}>
                          {getPostedLabel(article.postedtime)}
                        </div>
                      )}
                      <div style={{ color: '#666', fontSize: '0.85rem', lineHeight: 1.6, wordWrap: 'break-word', whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {article.aboutdescription && article.aboutdescription.split('\n').map((line, i) => (
                          <div key={i} style={{ marginBottom: 4 }}>{line}</div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
                {(idx + 1) % 3 === 0 && (
                  <li key={`ad-ls-${idx}`} style={{ padding: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '12px 0' }}>
                    {/* Google Ad Placeholder */}
                    <div style={{ width: 320, height: 100, background: '#f5f5f5', border: '2px dashed #ddd', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', fontSize: 14, fontWeight: 500 }}>
                      Advertisement Space
                    </div>
                  </li>
                )}
              </React.Fragment>
            ))}
          </ul>
        ) : (
          <div style={{ margin: '40px 0', padding: '40px 20px', textAlign: 'center', background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)' }}>
            <p style={{ color: '#888', fontSize: '1.1rem', margin: 0 }}>No Life Style articles yet.</p>
          </div>
        )
      )}

      {/* Render interview or current affairs modal with overlay */}
      {(openAid && (interviewComponents[openAid] || curaffairsComponents[openAid] || lifestyleComponents[openAid])) && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.45)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 12,
            width: 'min(96vw, 980px)',
            maxWidth: '98vw',
            maxHeight: '96vh',
            overflowY: 'auto',
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            position: 'relative',
          }}>
            <button
              onClick={handleCloseModal}
              style={{
                position: 'absolute',
                top: 10,
                right: 16,
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '6px 14px',
                fontWeight: 700,
                fontSize: '1.1rem',
                cursor: 'pointer',
                zIndex: 10,
              }}
            >
              ×
            </button>
            <div style={{ padding: '2.5rem 1.5rem 1.5rem 1.5rem', minWidth: 320, minHeight: 200 }}>
              {openAid && interviewComponents[openAid] && (
                React.createElement(interviewComponents[openAid], { onClose: handleCloseModal })
              )}
              {openAid && curaffairsComponents[openAid] && (
                React.createElement(curaffairsComponents[openAid], { onClose: handleCloseModal })
              )}
              {openAid && lifestyleComponents[openAid] && (
                React.createElement(lifestyleComponents[openAid], { onClose: handleCloseModal })
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Specials;
